import useMapEnum from "src/functions/mappers/use-map-enum";
import { EmploymentStatus_Enum } from "src/types/enums";

// Carer excluded: backend cannot map its occupationStatusId, causing null employment status on submission
const employmentStatusOptions = useMapEnum(Object.values(EmploymentStatus_Enum))
  .filter(option => option.value !== EmploymentStatus_Enum.Carer)

export default employmentStatusOptions;
